import config from 'config/default'

const { baseUrl } = config

/**
 * 获取某一课程的详情
 * @param theme
 * @param id
 */
export const getCourse = async ({ theme, id }) => {
    const url = `${baseUrl}/data/course/${theme}/${id}.json`
    return await fetch(url)
        .then(resp => resp.json())
        .catch(() => null)
}